module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7j47c"))).then(() => parcelRequire('f4eak'));